const getRootPath = (pathname: string) => `/${pathname.split('/')[1] || ''}`;

export default getRootPath;
